import { Translatable } from './model-translation';

export enum EventTypeId {
  CONFERENCE = 1,
  SPORT,
  PRIVATE_EVENT,
  CULTURE,
}

export interface EventType extends Translatable {
  id: number;
  name: string;
}
